// Mensagens prontas: o texto vem das Regras do salão; o envio é pelo WhatsApp de quem atende,
// com o texto já preenchido (sem integração automática por enquanto). Só para quem autorizou.
import { waLink } from './format.ts';

export const MSG_META: Array<{ key: string; when: string; label: string; desc: string; sample: Record<string, string> }> = [
  { key: 'confirmacao', when: 'Um toque por horário', label: 'Confirmação do horário', desc: 'Sai pelo botão do WhatsApp na tela Lembretes e no cartão do horário. Pede para a cliente confirmar ou remarcar respondendo.', sample: { nome: 'Ana', servico: 'Blindagem / MÃO', profissional: 'Valéria', dia: 'amanhã', hora: '14:00', link: '' } },
  { key: 'atraso', when: 'Quando passa do horário e ela não chegou', label: 'Está a caminho?', desc: 'Sai pelo botão Mensagem na tela Hoje, quando a cliente está atrasada. Pergunta se ela está a caminho.', sample: { nome: 'Ana', servico: 'Blindagem / MÃO', profissional: 'Valéria', dia: 'hoje', hora: '14:00', link: '' } },
];
export const MSG_VARS: Array<[string, string]> = [['{nome}', 'nome'], ['{servico}', 'serviço'], ['{profissional}', 'profissional'], ['{dia}', 'dia'], ['{hora}', 'hora'], ['{link}', 'link']];

export function fill(text: string, v: Record<string, string>): string {
  return text.replace(/\{(\w+)\}/g, (_, k: string) => v[k] ?? '').replace(/[ \t]+([.,!?])/g, '$1').replace(/[ \t]{2,}/g, ' ').replace(/[ \t]+\n/g, '\n').replace(/\n{3,}/g, '\n\n').trim();
}

export function sendWhatsApp(phone: string, text: string) {
  window.open(waLink(phone, text), '_blank', 'noopener');
}

// Quando o texto depende de um link criado na hora: a janela abre já no toque (o celular bloqueia
// janela aberta depois de esperar a internet) e recebe o endereço do WhatsApp quando o link chega.
export async function sendWhatsAppAfter(phone: string, build: () => Promise<string>) {
  const w = window.open('', '_blank');
  try {
    const url = waLink(phone, await build());
    if (w) { w.opener = null; w.location.href = url; } else window.location.href = url;
  } catch (e) { w?.close(); throw e; }
}

export const absolute = (path: string) => `${window.location.origin}${path}`;

// Mensagem de confirmação do horário, com o texto que a dona editou em Mensagens.
// Com o agendamento online ligado, leva também o link para confirmar, remarcar ou cancelar.
export async function confirmationText(
  settings: { messages?: Record<string, { on: boolean; text: string }>; onlineBooking?: boolean },
  vars: Record<string, string>,
  linkPath: () => Promise<string>,
): Promise<string> {
  if (settings.onlineBooking === false) return message(settings.messages, 'confirmacao', { ...vars, link: '' });
  const link = absolute(await linkPath());
  const text = message(settings.messages, 'confirmacao', { ...vars, link });
  return text.includes(link) ? text : `${text}\n\nPara confirmar, remarcar ou cancelar: ${link}`;
}

// versões sem link, para quando o agendamento online está pausado (marcar é pela conversa)
const SEM_LINK: Record<string, string> = {
  confirmacao: 'Oi, {nome}! Passando para confirmar seu horário {dia}: {servico} com {profissional}, às {hora}. Está tudo certo para você? É só responder aqui para confirmar ou remarcar.',
  retorno: 'Oi, {nome}, saudade de você por aqui! Que tal renovar o {servico}? É só responder aqui que eu separo um horário.',
  manutencao: 'Oi, {nome}! Está chegando a hora da manutenção do seu {servico}. Quer marcar com {profissional}? É só responder aqui.',
  falta: 'Oi, {nome}! Sentimos sua falta hoje às {hora}. Quer remarcar? É só responder aqui com o melhor horário para você.',
};

// texto pronto de uma mensagem das Regras, com as variáveis do horário
export function message(messages: Record<string, { on: boolean; text: string }> | undefined, key: string, v: Record<string, string>): string {
  const text = messages?.[key]?.text ?? '';
  if (!v.link && text.includes('{link}') && SEM_LINK[key]) return fill(SEM_LINK[key], v);
  return fill(text, v);
}
